import { Capacitor } from '@capacitor/core';
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style } from '@capacitor/status-bar';

// Check if running on native platform
export const isNativePlatform = () => {
  return Capacitor.isNativePlatform();
};

// Get platform name (ios, android, web)
export const getPlatform = () => {
  return Capacitor.getPlatform();
};

// Initialize native features
export const initNativeFeatures = async () => {
  if (!isNativePlatform()) {
    console.log('Running on web - skipping native initialization');
    return;
  }

  try {
    // Hide splash screen with fade
    await SplashScreen.hide({
      fadeOutDuration: 300
    });

    // Configure status bar for Hapag-Lloyd branding
    await StatusBar.setStyle({ style: Style.Dark });
    
    if (getPlatform() === 'android') {
      await StatusBar.setBackgroundColor({ color: '#111565' });
    }

    console.log(`FacilityPro initialized on ${getPlatform()}`);
  } catch (error) {
    console.error('Error initializing native features:', error);
  }
};

// Show splash screen (useful for loading states)
export const showSplash = async () => {
  if (!isNativePlatform()) return;
  
  try {
    await SplashScreen.show({
      autoHide: false
    });
  } catch (error) {
    console.error('Error showing splash:', error);
  }
};

// Hide splash screen
export const hideSplash = async () => {
  if (!isNativePlatform()) return;
  
  try {
    await SplashScreen.hide({
      fadeOutDuration: 300
    });
  } catch (error) {
    console.error('Error hiding splash:', error);
  }
};

// Set status bar visibility
export const setStatusBarVisible = async (visible) => {
  if (!isNativePlatform()) return;
  
  try {
    if (visible) {
      await StatusBar.show();
    } else {
      await StatusBar.hide();
    }
  } catch (error) {
    console.error('Error setting status bar visibility:', error);
  }
};

// Platform-specific utilities
export const mobileUtils = {
  isNative: isNativePlatform,
  platform: getPlatform,
  
  // Check if running on iOS
  isIOS: () => getPlatform() === 'ios',
  
  // Check if running on Android
  isAndroid: () => getPlatform() === 'android',
  
  // Check if running on web
  isWeb: () => getPlatform() === 'web',
  
  // Get safe area insets for iOS notch handling
  getSafeAreaInsets: () => {
    if (typeof CSS !== 'undefined' && CSS.supports) {
      return {
        top: getComputedStyle(document.documentElement).getPropertyValue('--sat') || '0px',
        bottom: getComputedStyle(document.documentElement).getPropertyValue('--sab') || '0px',
        left: getComputedStyle(document.documentElement).getPropertyValue('--sal') || '0px',
        right: getComputedStyle(document.documentElement).getPropertyValue('--sar') || '0px',
      };
    }
    return { top: '0px', bottom: '0px', left: '0px', right: '0px' };
  }
};

export default {
  init: initNativeFeatures,
  showSplash,
  hideSplash,
  setStatusBarVisible,
  ...mobileUtils
};
